// Reject seconds, missing values and invalid dates instead of using the device clock.
export const isValidServerTime = time => (
  Number.isFinite(time) && time >= 1000000000000 && time <= 8640000000000000
)
